import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * Fetches the list of non-pending approval person invoices older than 6 months
 * @returns {Promise} - API response containing list of invoices
 */
export const getNonPendingInvoicesOlderThan6Months = async () => {
  try {
    const response = await apiClient.get(
      '/approvalPersonSystemInvoiceManagement/invoice/list-non-pending-older-than-6-months'
    );

    // Handle the response structure: { status, message, response } or direct array
    if (response.data?.response && Array.isArray(response.data.response)) {
      return response.data.response;
    }

    // Fallback to direct data if structure is different
    return response.data?.response || response.data || [];
  } catch (error) {
    handleApiError(error);
    return [];
  }
};
